import React from 'react';

import { IEditableServerSettings } from '~src/settings/ServerApi/types/IEditableServerSettings';

export type ErrorValidator<T extends { settings?: object }> = (props: T) => string;
export type TouchCalculator<T extends { settings?: object }> = (props: T) => boolean;
export type ComponentSpecs<Props extends { settings?: object }> = {
  name: string;
  component: React.ComponentType<Props>;
  onSubmit?: (settings: Props['settings'], previousServerSettings?: IEditableServerSettings) => Promise<Props['settings'] | void> | void;

  // Prop is to transform settings coming from BE before render Section, so formik fields have this value
  transformSettingsOnLoad?: (settings: Readonly<Props['settings']>) => Props['settings'];

  // Prop is to transform settings before submit to BE if need to transform these user inputted values
  transformSettingsBeforeSubmit?: (settings: Readonly<Props['settings']>) => Props['settings'];
  meta?: {
    [k in keyof Props['settings']]?: {
      initError: ErrorValidator<Props>;
      initTouched: TouchCalculator<Props>;
    }
  };
};

/**
 * A helper function, used as a workaround to get stronger types when passing specs to createComponentRegistry
 * @param specs
 */
export function componentRegistryEntry<Props>(specs: ComponentSpecs<Props>) {
  return specs;
}
